const state = {
  detailUser: {},
};

const getters = {
  detailUser(state) {
    return state.detailUser;
  },
};

const mutations = {
  UPDATE_DETAIL_USER(state, detailUser) {
    state.detailUser = detailUser;
  },
};

const actions = {
  updateDetailUser({ commit }, detailUser) {
    commit('UPDATE_DETAIL_USER', detailUser);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
